export default function CreatedByCell({ value }: { value?: string }) {
  return <div className="text-white text-break text-wrap fs-6">{value}</div>;
}